export default String.raw`
{% assign postDetails = blog.PostDetails %}
{% assign latestPosts = blog.LatestPosts %}

{% assign postImage = postDetails.ImageUrl -%}
{% assign postTitle = postDetails.Heading -%}
{% capture shopBase -%}{% include 'partials/common/absolute-base.html' -%}{% endcapture -%}
{% assign postUrl = shopBase | Append: postDetails.Url -%}

{% include 'partials/common/date-format.html' -%}

<div class="blog-post">
	<div class="blog-post__main">
		<article class="blog-post__article article">
			<header class="article__header">
				<h1>{{postTitle}}</h1>
				<div class="article__metadata">
					<div class="article__metadata-tags">
						{% for tag in postDetails.Tags -%}
							{% if tag.Text != "" %}
								<a href="{{ page.BaseHref }}{{ tag.Url }}">#{{ tag.Text }}</a>
							{% endif %}
						{% endfor -%}
					</div>
					<div class="article__metadata-time">
						<span>~  {{ postDetails.ReadTime }} {{translations.ReadTime}}</span>
						<time datetime="{{ postDetails.PublishedDate | Date: 'yyyy-MM-dd HH:mm:ss' }}">{{ postDetails.PublishedDate | Date:dateFormat }}</time>
					</div>
				</div>
			</header>
			{% if postImage %}
				<div class="article__image">
					<img src="{{ postDetails.ImageUrl }}" alt="{{ postDetails.ImageAlt }}" title="{{ postDetails.ImageTitle }}">
				</div>
			{% endif %}
			<section class="article__content">
				{{ postDetails.Content }}
			</section>
			<footer class="article__footer">
				<div class="article__footer-share">
					<span>{{translations.ArticleShare}}</span>
					<a href="https://www.linkedin.com/sharing/share-offsite/?url={{postUrl}}" target="_blank" title="LinkedIn">
						<svg height="24" width="24">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#linkedin"></use>
						</svg>
					</a>
					<a href="https://www.facebook.com/sharer/sharer.php?u={{postUrl}}" target="_blank" title="Facebook">
						<svg height="24" width="24">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#facebook"></use>
						</svg>
					</a>
					<a href="https://twitter.com/intent/tweet?text={{postTitle}}&amp;nbsp;&url={{postUrl}}" target="_blank" title="X">
						<svg height="24" width="24">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#x-twitter"></use>
						</svg>
					</a>
				</div>

				<h2 class="blog-post__all-articles">
					<a href="{{ page.BaseHref }}{{config.DefinedPages.Blog.Url}}" class='blog-post__all-articles-link'>
						{{translations.allArticles}}
						<svg height="14" width="14">
							<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{settings.iconStyle}}'></use>
						</svg>
					</a>
				</h2>
			</footer>
		</article>
		<div class='blog-post__sidebar sidebar'>
				<h2 class="blog-post__all-articles">
					<a href="{{ page.BaseHref }}{{config.DefinedPages.Blog.Url}}" class='blog-post__all-articles-link'>
						{{translations.allArticles}}
						<svg height="14" width="14">
							<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{settings.iconStyle}}'></use>
						</svg>
					</a>
				</h2>
				{% if postDetails.Previous or postDetails.Next %}
					{% if postDetails.Previous %}
					<div class="sidebar__next-article">
						<h3 class="sidebar__header">{{translations.NextArticle}}</h3>
						<article class="blog-item">
							{% assign sizePost=postDetails.Previous.Content | StripHtml | Size | Minus: 4 -%}
							<a class href="{{ page.BaseHref }}{{ postDetails.Previous.Url }}">
								<div class="blog-item__img">
									<img src="css/img/alo.gif" data-src="{{ postDetails.Previous.ImageUrl }}" alt="{{ postDetails.Previous.ImageAlt }}" title="{{ postDetails.Previous.ImageTitle }}">
								</div>
							</a>
							<div class="blog-item__right-section">
								<div class="blog-item__right-section-wrapper">
									<h3 class="blog-item__title">{{ postDetails.Previous.Heading }}</h3>
									<span>~ {{ postDetails.Previous.ReadTime }} {{translations.ReadTime}}</span>
								</div>
								<p class='blog-item__content'>{{ postDetails.Previous.Content }}</p>
								<div class="blog-item__read">
									<div class="blog-item__read-top">
										<time datetime="{{ postDetails.Previous.PublishedDate | Date: 'yyyy-MM-dd HH:mm:ss' }}">{{ postDetails.Previous.PublishedDate | Date:dateFormat }}</time>
										<div class="blog-item__read-top-tags">
											{% for tag in postDetails.Previous.Tags -%}
												{% if tag.Text != "" %}
													<a href="{{ page.BaseHref }}{{ tag.Url }}">#{{ tag.Text }}</a>
												{% else -%}
													&nbsp;
												{% endif %} 
											{% endfor -%}
										</div>
									</div>
									<div class="blog-item__read-bottom">
										<div class="blog-item__read-bottom-time">
											<span class="blog-item__read-time">~ {{ postDetails.Previous.ReadTime }} {{translations.ReadTime}}</span>
										</div>
										<div class="blog-item__read-bottom-button">
											<a href="{{ page.BaseHref }}{{ postDetails.Previous.Url }}">
												{{translations.ReadMore}}
												<svg>
													<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{settings.iconStyle}}'></use>
												</svg>
											</a>
										</div>
									</div>
								</div>
							</div>
						</article>
					</div>
					{% endif %}
				{% endif %}
				<div class="sidebar__latests-posts">
					<h3 class="sidebar__header">{{translations.LastArticles}}</h3>
					<div class="swiper blog-swiper-js">
						{% for lastArticles in latestPosts limit:3 -%}
						<article class="blog-item swiper-slide">
							{% assign sizePost=lastArticles.Content | StripHtml | Size | Minus: 4 -%}
							<a class="blog-item__wrapper" href="{{ page.BaseHref }}{{ lastArticles.Url }}">
								{% if lastArticles.ImageUrl -%}
									<div class="blog-item__img">
										<img src="css/img/alo.gif" data-src="{{ lastArticles.ImageUrl }}" alt="{{ lastArticles.ImageAlt }}" title="{{ lastArticles.ImageTitle }}" loading ="eager" fetchpriority="high">
									</div>
								{% endif %}
								<h2 class="blog-item__title">{{ lastArticles.Heading }}</h2>
								<p class='blog-item__content'>{{ lastArticles.Content | StripHtml | Slice: 0,sizePost }}</p>
							</a>
							<div class="blog-item__read">
								<div class="blog-item__read-top">
									<time datetime="{{ lastArticles.PublishedDate | Date: 'yyyy-MM-dd HH:mm:ss' }}">{{ lastArticles.PublishedDate | Date:dateFormat }}</time>
									<div class="blog-item__read-top-tags">
										{% for tag in lastArticles.Tags -%}
											{% if tag.Text != "" %}
												<a href="{{ page.BaseHref }}{{ tag.Url }}">#{{ tag.Text }}</a>
											{% else -%}
												&nbsp;
											{% endif %}
										{% endfor -%}
									</div>
								</div>
								<div class="blog-item__read-bottom">
									<div class="blog-item__read-bottom-button">
										<a href="{{ page.BaseHref }}{{ lastArticles.Url }}">
											{{translations.ReadMore}}
											<svg>
												<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{settings.iconStyle}}'></use>
											</svg>
										</a>
									</div>
								</div>
							</div>
						</article>
						{% endfor -%}
					</div>
				</div>
		</div>
	</div>
</div>
`